import { Form, FormInstance, Input, Typography } from 'antd';
import React, { useContext } from 'react';
import { useEffect } from 'react';
import { MESSAGE_LENGTH, PHONE_LENGTH } from '../virtual-assistant.constants';
import { EmailFormData } from '../vitrual-assistant.type';
import { PartContext } from '../virtual-assistant';
import { filterDigits, localize } from '/site/mixins/helpers';
import {
    handleInputKeyDownOnlyDigit,
    handleInputKeyDownPhone,
    handleInputOnChangeOnlyDigit,
    handleInputOnChangePhone
} from "mixins/helpers";

interface OperatorRequestFormProps {
    emailForm: FormInstance<EmailFormData>;
    setIsValid: React.Dispatch<React.SetStateAction<boolean>>;
}

const OperatorRequestForm = ({ emailForm, setIsValid }: OperatorRequestFormProps) => {
    const values = Form.useWatch([], emailForm);
    const { translations } = useContext(PartContext);

    useEffect(() => {
        emailForm
            .validateFields()
            .then(() => {
                setIsValid(true);
            })
            .catch(() => setIsValid(false));
    }, [values]);

    return (
        <Form
            layout="vertical"
            form={emailForm}
            style={{ padding: '0 2rem' }}
        >
            <Typography>{localize('form-title', translations)}</Typography>
            <Form.Item
                label={localize('labels.fullname', translations)}
                name="fullname"
                rules={[
                    {
                        required: true,
                        message: localize('validation.contact', translations),
                    },
                ]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                label={localize('labels.phone', translations)}
                name="phoneNumber"
                rules={[
                    {
                        required: !values?.email,
                        message: localize('validation.contact', translations),
                    },
                    {
                        len: 11,
                        message: localize('validation.phone-format', translations),
                    },
                ]}
            >
                <Input
                    maxLength={PHONE_LENGTH}
                    prefix="+"
                    onKeyDown={handleInputKeyDownPhone}
                    onChange={handleInputOnChangePhone}
                />
            </Form.Item>
            <Form.Item
                label="Email"
                name="email"
                rules={[
                    {
                        required: !values?.phoneNumber,
                        message: localize('validation.contact', translations),
                    },
                    {
                        type: 'email',
                        message: localize('validation.email-format', translations),
                    },
                    // {
                    //     max: EMAIL_LENGTH,
                    //     message: localize('validation.email-length', translations),
                    // },
                ]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                label={localize('labels.message', translations)}
                name="content"
                required
                rules={[
                    {
                        required: true,
                        message: localize('validation.message', translations),
                    },
                    {
                        max: MESSAGE_LENGTH,
                        message: localize('validation.message-length', translations),
                    },
                ]}
            >
                <Input.TextArea />
            </Form.Item>
        </Form>
    );
};

export default OperatorRequestForm;
